var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shifts-surplus-mark",style:({color: _vm.surplus.color})},[_vm._v(_vm._s(_vm.surplus.mark))])
}
var staticRenderFns = []

export { render, staticRenderFns }